import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { setSidebar } from "../../app/appSlice";
import { TopBar } from "../../components/topBar/topBar";
import { useAppDispatch } from "../../hooks/hooks";
import { useSecureApplication } from "../../hooks/KeycloackConnection";
import { useImportTopology } from "./import/UseImportTopology";
import { NewTopologyForm } from "./NewTopologyForm";
import { initImportTopology } from "./TreatmentSlice";
import { LabelsSelectorsProvider } from '@kosmos/shared';


export const chooseOptions = {
  icon:"pi pi-upload",
  className: "m-2 p-button-text",
  label: "Importer un traitement"
};

export const NavBar = () => {

    const {hasAnyPerm} = useSecureApplication()
    const  dispatch = useAppDispatch()
    const {onSelectFile,fileUploadRef} = useImportTopology()


    return (
        <>
        <TopBar right={ <div className="flex">
         {hasAnyPerm("pipelines.all", "pipelines_create") && <FileUpload
          ref={fileUploadRef}
          mode="basic"
          multiple={false}
          accept=".json"
          maxFileSize={1000000}
          onSelect={onSelectFile}
          disabled={false}
          chooseOptions={chooseOptions}
        />}

            <Button
              icon="pi pi-plus"
              label={"Créer un traitement"}
              onClick={() =>
                dispatch(
                  setSidebar({
                    title: "Nouveau",
                    content: (
                        <LabelsSelectorsProvider serviceUrl="/api/labels?vstoreobject=topologies">
                          <NewTopologyForm
                            onClose={() => {
                              dispatch(setSidebar());
                              dispatch(initImportTopology())
                            }}
                          />
                        </LabelsSelectorsProvider>
                    ),
                  })
                )
              }
              disabled={!hasAnyPerm("pipelines.all", "pipelines_create")}
              className="mr-3 mt-2 ml-2 mb-2"
            />
          </div>} left={<h2>Traitements</h2>}/>
          </>
    )
}

 